<template>
  <main v-if="!ssoFlg" class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner-red">
        <div class="l-error__message l-error__message--red">
          <span>
            <IconAlert />
          </span>
          <p v-if="ssoFlg">
            ログイン画面からのアクセスをお願いします。
            <br />
            ブラウザの「×」(閉じる)ボタンで閉じてください。
          </p>
          <p v-else>
            セッションタイムアウトになりました。
            <br />
            お手数ですが、再度ログインしてください。
          </p>
        </div>

        <div v-if="!ssoFlg" class="l-error__btn">
          <div class="c-buttonWrap4">
            <ButtonLink
              tag="a"
              :href="redirectUrl"
              style-type="primary"
              color="color2"
            >
              ログイン
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  </main>
  <main v-else class="c-common-footer-fixed-no-login">
    <div class="c-common-footer-fixed-no-login__inner">
      <div class="p-sso-logout">
        <h3>SSO Access Error</h3>
        <p>認証エラーもしくはセッションタイムアウトしました。</p>
        <p>
          ブラウザの「×」（閉じる）ボタンで閉じてください。再度、エラーとなる場合は担当者様にご確認ください。
        </p>
      </div>
    </div>
    <TheFooter />
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import loginInfo from "@/general/store/modules/loginInfo";
import ButtonLink from "@/common/components/atoms/ButtonLink.vue";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import meta from "@/general/store/modules/meta";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Options({
  props: {
    error: { type: Boolean, required: false, default: false }
  },
  components: {
    ButtonLink,
    IconAlert
  }
})
export default class ErrorSession extends Vue {
  error!: boolean;
  ssoFlg = false;

  get redirectUrl() {
    // 戻り先 url の設定が必要
    return (
      process.env.VUE_APP_AUTH_FACADE +
      "?callback_authorization_start_uri=" +
      process.env.VUE_APP_API_DOMAIN +
      "/v1/top/auth-start"
    );
  }
  get title() {
    const metaTitle = process.env.VUE_APP_PAGE_TITLE;
    return metaTitle;
  }

  get currentHref() {
    return window.location.href;
  }
  async created() {
    // SSOログアウト判定フラグ trueの場合はSSOエラー画面用の文言を表示する。
    this.ssoFlg = loginInfo.isSso;
  }

  async mounted() {
    if (!this.ssoFlg) {
      await meta.setDocumentTitle("セッションタイムアウトになりました。");
    }

    LocalStorage.removeAll();
    AuthApi.getLogout();
    auth.remove();
    /*
    const login_facade =
      process.env.VUE_APP_AUTH_FACADE +
      "?callback_authorization_start_uri=" +
      process.env.VUE_APP_API_DOMAIN +
      "/v1/top/auth-start";
    window.location.href = login_facade;
    */

    // document Titleの設定
    // this.$meta.setDocumentTitle("セッションタイムアウトになりました。");
    // this.$page.isBreadcrumb = false;
    // this.$page.isPageHeader = false;
    // this.$page.isPageTop = false;
    // this.$page.isSubHeader = true;
    // this.$page.showFooterMenu = false;
    // Remove logic authenticationLevel
    // if(this.$route.query.authenticationLevel != 1){
    //   this.logout();
    // }
  }
}
</script>

<style lang="scss" scoped></style>
